// Wrapper fino sobre el SDK cliente de PostHog (ya cargado en public/index.html).
// Nunca debe romper una acción real del usuario si falla.
export function track(event, properties = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, properties);
    }
  } catch {
    // silencioso — analytics nunca debe romper el flujo real
  }
}

export function identify(userId, traits = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.identify === "function") {
      window.posthog.identify(userId, traits);
    }
  } catch {
    // silencioso
  }
}
